import { UseQueryResult, useQuery } from 'react-query';
import { ArmReport, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseArm {
  month: string | null;
  type: 'total' | 'paying';
  enabled?: boolean;
}

function useArm({ month, type, enabled = true }: IUseArm): UseQueryResult<{ data: ArmReport }> {
  const params: UrlParams = {};

  if (month) {
    params.month = month;
  }
  params.type = type;

  return useQuery(['arm', month, type], () => client.get(`reports/arm?${encodeUrlParams(params)}`), {
    enabled: !!month && enabled,
    staleTime: 86400000, // 1 day
  });
}

export default useArm;
